import React, { useState, useEffect } from "react";
import { Tab, Nav, Container } from "react-bootstrap";
import jsDig from "utils/jsDig";
import enTranslations from '@shopify/polaris/locales/en.json';
import {AppProvider, Page, Card, Button, Badge, List, TextContainer, TextStyle} from '@shopify/polaris';

export default function Dashboard(props) {
  const breadcrumbs = [{content: 'DataPulse Bridge by Digital Position', onAction: () => props.onNavigate("app")}];

  return (
    <AppProvider i18n={enTranslations}>
      <Page 
        fullWidth 
        title="Dashboard"
        breadcrumbs={breadcrumbs}
      >
        <Card title="Metrics" sectioned>
          {props.account_configured ? (
            <>
              <TextContainer>
                <p className="mb-4">Your data was last pulled successfully on: 
                  <TextStyle variation={props.last_updated ? "positive" : "negative"}> { props.last_updated ? props.last_updated.split("T")[0] : "Never" }</TextStyle>
                </p>
              </TextContainer>
              <TextContainer>
                <p className="mb-4">Your performance for the current month is:</p>
              </TextContainer>
              <TextContainer>
                <List type="bullet">
                  <List.Item><b>Shopify Revenue: </b>${ jsDig(["revenue"], props).toFixed(2) }</List.Item>
                </List>
              </TextContainer>
            </>
          ) : (
            <>
              <TextContainer>
                <p className="mb-4">Even though you have successfully installed the DataPulse Bridge shopify app, it looks like your store ({props.shop}) hasn't been configured in DataPulse yet. DataPulse is where your real dashboards live, but you may see the data we are pulling from Shopify on this page once we have finished configuring your account. Reach out to your Digital Position representative to address this issue.</p>
              </TextContainer>
            </>
          )}
        </Card>
      </Page>
    </AppProvider>
  )
}